import React from 'react';
import HeaderAccount from "./commons/components/header";
import FooterAccount from "./commons/components/footer"
import { Layout } from "antd";

import './App.css';
import "antd/dist/antd.css";

import Login from "./pages/login"

const { Header, Content, Footer } = Layout;

export default props => {
    return (
        <div className="App">
            <Layout className="layout" style={{ minHeight: "100vh", width: "100%" }}>
                <Header style={{ minHeight: "82px", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <HeaderAccount applicationId={2} />
                </Header>
                <Content style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Login/>
                </Content>
                <Footer style={{ minHeight: "82px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FooterAccount />
                </Footer>
            </Layout>
        </div>
    )
}


